import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { AppStore } from '../../store/store';
import { UserState } from '../../store/user.slice';
import { Roles } from '../../utils/roles';

interface MerchantGuardProps {
    children: ReactNode;
}

const MerchantGuard: React.FC<MerchantGuardProps> = ({ children }) => {
    const { user } = useSelector<AppStore, UserState>((state) => state.user);

    const isMerchant = (
        user?.roles?.includes(Roles.MERCHANT) ||
        user?.roles?.includes(Roles.BAS_MERCHANT_VIEW) ||
        user?.roles?.includes(Roles.MULTI_MERCHANT_VIEW)
    );

    if (isMerchant) {
        return <Navigate to="/app/dashboard" replace />;
    } else {
        return <>{children}</>;
    }
};

export default MerchantGuard;
